import React from 'react';

export function ConnectFooter(): JSX.Element {
  return <footer id="GlobalFooter" data-testid="GlobalFooter" />;
}
